/**
 * @class
 * @extends mkE.Base
 */
T.Pg = Class(
	/**
	 * @lends {T.Pg#}
	 */
	{
		par: null,
		__construct: function(par){
			this.pg = par.pg || 1;
			this.pgs = par.pgs || 1;
			this.callback = par.callback || function(pg){
			};
			this.backNext = typeof par.backNext != 'undefined' ? par.backNext : true;
			this.count = par.count || 7;
			this.node = mkE({
				tag: 'div',
				className: 'navigBg'
			});
			this.draw();
		},
		nextPage: function(){
			if( this.pg == this.pgs ){
				return;
			}
			if( this.callback(this.pg + 1) === false ){
				return;
			}
			++this.pg;
			this.draw();
		},
		prevPage: function(){
			if( this.pg <= 1 ){
				return;
			}
			if( this.callback(this.pg - 1) === false ){
				return;
			}
			--this.pg;
			this.draw();
		},
		gotoPage: function(pg){
			if( this.callback(pg) === false ){
				return;
			}
			this.pg = pg;
			this.draw();
		},
		value: function(v){
			if( isset(v) && v > 0 && v <= this.pgs ){
				if( this.pg == v ){
					return this.pg;
				}
				this.pg = v;
				this.draw();
			}
			return this.pg;
		},
		draw: function(){
			if( this.pgs < 2 ){
				return;
			}
			var table_tr;
			clearNode(this.node);
			mkE({
				tag: 'table',
				className: 'navig',
				els: [
					table_tr = mkE({
						tag: 'tr'
					})
				]
			}).append(this.node);

			if( this.backNext ){
				mkE({
					tag: 'td',
					className: this.pg == 1 ? 'hidden' : 'first icn',
					els: [
						{
							tag: 'a',
							href: 'javascript:',
							onclick: this.prevPage
						}
					]
				}).append(table_tr);
			}

			var total = this.count;
			var pause = false;

			for( var i = 1; i <= this.pgs; i++ ){
				if( total == 2 && i < (this.pgs - 1) ){
					pause = true;
				}
				var className = '';
				if( pause ){
					var txt = '...';
					className = 'pause';
					pause = false;
				} else{
					var txt = i;
				}

				if( i == 1 && (i == this.pg || !this.backNext) ){
					className = this.pgs == 1 ? 'first last' : 'first';
				} else if( i == this.pgs && (i == this.pg || !this.backNext) ){
					className = 'last';
				}

				mkE({
					tag: 'td',
					className: className,
					els: [
						{
							tag: 'a',
							className: this.pg == i ? 'active' : '',
							href: 'javascript:',
							text: txt,
							onclick: D.closure(this, this.gotoPage, i)
						}
					]
				}).append(table_tr);

				total--;
				if( i == 1 ){
					i = Math.max(1, Math.min(this.pgs - total, this.pg - 2));
					if( i > 1 ){
						pause = true;
					}
				} else if( total == 1 && i < this.pgs ){
					i = this.pgs - 1;
				}
			}

			if( this.backNext ){
				mkE({
					tag: 'td',
					className: this.pg == this.pgs ? 'hidden' : 'last icn',
					els: [
						{
							tag: 'a',
							href: 'javascript:',
							onclick: this.nextPage
						}
					]
				}).append(table_tr);
			}
		}
	},
	mkE.Base
);